import { formatCurrency } from '@helpers/utils';
import moment from 'moment';

export const INFORMATION_COLUMN = [
    {
        title: 'Total SKU',
        key: 'total_sku',
        value: (value) => value?.toLocaleString() ?? '0',
    },
    {
        title: 'Total Qty',
        key: 'total_qty',
        value: (value) => value?.toLocaleString() ?? '0',
    },
    {
        title: 'Total Value',
        key: 'total_value',
        value: (value) => (value ? formatCurrency(value) : formatCurrency(0)),
    },
    {
        title: 'Total Final Value',
        key: 'total_final_value',
        value: (value) => (value ? formatCurrency(value) : formatCurrency(0)),
    },
    {
        title: 'Tipe Sell Out',
        key: 'sellout_type',
        value: (value) => (value ? value[0].toUpperCase() + value.slice(1) : '-'),
    },
    {
        title: 'Tanggal/Waktu Upload',
        key: 'date_upload',
        value: (value) => (value ? `${moment(value).format('DD MMMM YYYY - HH:mm:ss')} WIB` : '-'),
    },
    {
        title: 'Success',
        key: 'total_success',
        value: (value) => (value ? value?.toLocaleString() : '0'),
    },
    {
        title: 'Failed',
        key: 'total_failed',
        value: (value) => (value ? value?.toLocaleString() : '0'),
    },
    {
        title: 'Customer ID',
        key: 'customer_id',
        value: (value) => value || '-',
    },
    {
        title: 'Customer',
        key: 'customer_name',
        value: (value) => value || '-',
    },
    {
        title: 'Store Group ID',
        key: 'store_group_id',
        value: (value) => value || '-',
    },
    {
        title: 'Store Group',
        key: 'store_group',
        value: (value) => value || '-',
    },
    {
        title: 'Distribution Center',
        key: 'distribution_center',
        value: (value) => value || '-',
    },
    {
        title: 'External Reference',
        key: 'external_reference',
        value: (value) => value || '-',
    },
];
